import { useEffect, useState } from 'react';
import { getDocument, PDFWorker } from 'pdfjs-dist';
import * as Sentry from 'shared/domains/sentry';
import { useDocumentPDF } from './useDocumentPDF';
const workerInstance = new Worker(new URL('pdfjs-dist/legacy/build/pdf.worker.min.mjs', import.meta.url));
export const usePDF = () => {
    var _a;
    const { pdf: pdfFile, loading: pdfLoading, error: pdfError } = useDocumentPDF();
    const url = (_a = pdfFile === null || pdfFile === void 0 ? void 0 : pdfFile.signed) === null || _a === void 0 ? void 0 : _a.url;
    const [pdf, setPDF] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const handleErrors = (response) => {
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return response;
    };
    useEffect(() => {
        if (url && !pdf) {
            const worker = PDFWorker.fromPort({
                port: workerInstance,
            });
            fetch(url)
                .then(handleErrors)
                .then(response => response.arrayBuffer())
                .then(data => getDocument({ data, worker }).promise.catch(e => {
                if (!e) {
                    throw new Error('Unknown Error when loading PDF: getDocument() from "pdfjs-dist" returned "undefined" error');
                }
                else {
                    throw e;
                }
                setError(true);
            }))
                .then(instance => setPDF(instance))
                .catch(e => {
                Sentry.captureException(e);
                setError(true);
            })
                .finally(() => setLoading(false));
            return () => {
                worker.destroy();
            };
        }
        return undefined;
    }, [url, pdf]);
    return { pdf, loading: loading || pdfLoading, error: error || pdfError };
};
